export const REQUEST_COURSE_TAG_OPTIONS = 'REQUEST_COURSE_TAG_OPTIONS';
export const REQUEST_COURSE_TAG_OPTIONS_FAIL = 'REQUEST_COURSE_TAG_OPTIONS_FAIL';
export const REQUEST_COURSE_TAG_OPTIONS_SUCCESS = 'REQUEST_COURSE_TAG_OPTIONS_SUCCESS';
